<template>
  <slot-button 
    :btnClass="classes"
    :title="title"
    fab 
    :small="size === 'small'"
    :x-small="size === 'x-small' || size === 'xSmall'"
    :icon="icon"
    :text="text"
    @click="$emit('click', $event)">
    <slot></slot>
  </slot-button>
</template>

<script>
import slotButton from "./SlotButton";
export default {
  name: "circleSlotButton",
  components: {slotButton},
  props: {
    title: String,
    btnClass: String,
    icon: Boolean,
    text: Boolean,
    active: Boolean,
    size: { type: String, default: "small" }
  },
  computed: {
    classes(){
      let active = this.active ? "active" : "";
      return [active, this.btnClass, "rounded-button"].filter(c => c).join(" ");
    }
  }
}
</script>